import { z } from "zod"

export const JOB_SEARCH_STATUSES = ["active", "waiting", "delayed", "failed", "paused"] as const

export const JOB_ALL_STATUSES = [...JOB_SEARCH_STATUSES, "completed"] as const

export const BackofficeJobSearchQuerySchema = z.object({
  name: z.string().min(1).optional(),
  dataQuery: z.string().min(1).optional(),
  queue: z.enum(["CONVERSATION", "REALTIME", "BACKGROUND", "CAMPAIGN", "SERIAL"]).optional(),
  status: z.enum(JOB_ALL_STATUSES).optional(),
})
